import React from "react";
import "./context_menu_styles.css";
import MaterialIcon from "../../../components/BuilderComponents/MaterialIcon";
import { getContextMenuItems } from "./contextMenuUtils";
import { usePositionedScreenContext } from "../PositionedScreen";
import useItemHandler from "../PositionedHooks/useItemHandler";

const ContextMenuContent = ({ item, onClose }) => {
  const {
    layoutConfig,
    selectedItem,
    setSelectedItem,
    setLayoutConfig,
    type,
    setSelectedItemPath,
    setMultiSelectedItems,
    gridSize
  } = usePositionedScreenContext();

  const { duplicateElement, copyElement, pasteElement, cutElement, deleteElement } = useItemHandler({
    layoutConfig,
    setLayoutConfig,
    setSelectedItem,
    setSelectedItemPath,
    setMultiSelectedItems,
    type,
    gridSize
  });

  const menuItems = getContextMenuItems(selectedItem.type);

  const handleAction = (action) => {
    switch (action) {
      case "Copy":
        copyElement(selectedItem, item.otherInfo);
        break;
      case "Cut":
        cutElement(selectedItem, item.otherInfo);
        break;
      case "Paste":
        pasteElement(selectedItem, item.otherInfo);
        break;
      case "Duplicate":
        duplicateElement(selectedItem, item.otherInfo);
        break;
      case "Delete":
        deleteElement(selectedItem, item.otherInfo);
        break;
      default:
        console.warn("Unknown action:", action);
    }
    onClose();
  };

  return (
    <ul className="context_menu">
      <div className="context_menu_type_label">
        {(selectedItem.type === "element" ? selectedItem?.config?.type : selectedItem.type) || "Unknown"}
      </div>

      {menuItems.map((entry) => (
        <li
          key={entry.label}
          className={`context_menu_item ${entry.danger ? "context_menu_danger" : ""}`}
          onClick={() => handleAction(entry.action)}
        >
          <MaterialIcon name={entry.icon} className={`context_menu_icon ${entry.color}`} />
          <span className="context_menu_label">{entry.label}</span>
        </li>
      ))}
    </ul>
  );
};

export default ContextMenuContent;
